import "./postplayingtemplatetwo.css";
import {
  React,
  ReactPlayer,
  Marquee,
} from "../../../Libraries/Post/PostPlaying/index";
import DOMPurify from 'dompurify';

const PostPlayingTemplateTwo = (props) => {
  return (
    <div className="l2playing">
      {props?.data?.finalfile?.txt_media_file_type === "Image" ? (
        <div className="main">
          <img
            src={props.data.finalfile.txt_media_streaming_link}
            alt="img"
            width="100%"
          />
        </div>
      ) : props?.data?.finalfile.txt_media_file_type === "Video" ||
        props?.data?.finalfile?.txt_media_file_type === "Live" ? (
        <div className="main">
          <ReactPlayer
            url={props.data.finalfile.txt_media_streaming_link}
            loop={true}
            playing={true}
            playsInline
            controls
            width="100%"
            height="100%"
          />
        </div>
      ) : props?.data?.finalfile?.txt_media_file_type === "Widget" ? (
        <div className="main">
          {/* <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props?.data?.finalfile?.txt_media_streaming_link),
            }}
            style={{ height: "100%" }}
          /> */}
          <p>{props?.data?.finalfile?.txt_media_streaming_link}</p>
        </div>
      ) : null}
      <div className="footer">
        {/* <marquee>
          {props?.data?.footer.map((footerdes, index) => (
            <div key={index} className="mr-5">
              {footerdes.txt_footer_description}
            </div>
          ))}
        </marquee> */}
        <Marquee style={{ height: "100%", minHeight: 70 }} gradient={false}>
          {props?.data?.footer.map((footerdes, index) => (
            <div key={index} className="mr-5">
              {footerdes.txt_footer_description}
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default PostPlayingTemplateTwo;
